// Extract the review key (UUID) from an external-review URL.
// Accepted shapes:
//   https://host/#/review/<key>
//   https://host/#/review/<key>&_ga=…              (GA appended via &)
//   https://host/#/review/<key>&_ga=…&_gac=…       (GA + GAC)
//   https://host/#/review/<key>/posts/<postId>     (post deep-link)
//   https://host/review/<key>                      (top-level path fallback)
//
// Returns '' if the URL doesn't match. Previously this function used
// `new URLSearchParams(href)` and `.split('/')[5]` which only worked
// because URLSearchParams treats the entire URL as a single key — and
// the `urlParam.delete('&_ga')` calls were typos (the key is `_ga`,
// not `&_ga`), so they were no-ops. A bare regex over the hash is
// explicit and resilient to subdomain / path-segment changes.
export default (url: string): string => {
  const match = url.match(/(?:#\/review\/|https?:\/\/[^/]+\/review\/)([^/&?]+)/)
  return match ? match[1] : ''
}
